export default __webpack_public_path__ + "static/media/squarespace.4ff31123.png";